module.exports = __webpack_public_path__ + "media/images/redonner@2x-81de9584.png";